import clsx from 'clsx';

import styles from './HealthIndicatorSkeleton.module.css';

export const HealthIndicatorSkeleton = () => (
  <>
    <span className={clsx(styles.skeleton, styles.skeletonChild)} />
    <span className={clsx(styles.skeleton, styles.skeletonChild)} />
    <span className={clsx(styles.skeleton, styles.skeletonChild)} />
  </>
);
